export default [
  {
    name: '',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: ['57_r', '326_r', '56_r', '60_r', '59_r', '55_r', 35, 54],
    invert: [57, 326, 56, 60, 59, 55],
    negative: false,
    translationKey: 'chalkboard.defensive.team.goals_received',
    singleName: 'Gol recibido',
  },
  {
    name: '',
    color: '#FFFF00',
    points: [1, 2, 3],
    categories: ['510_r'],
    invert: [510],
    negative: false,
    translationKey: 'chalkboard.defensive.team.shots_on_goal_received',
    singleName: 'Tiro a gol recibido',
  },
  {
    name: '',
    color: '#9933FF',
    points: [1, 2, 3],
    categories: ['537_r', '540_r', '544_r', '547_r'],
    invert: [537, 540, 544, 547],
    translationKey: 'chalkboard.defensive.team.shots_on_goal_received',
    singleName: 'Tiro a gol recibido',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: ['13_r', '25_r'],
    invert: [13, 25],
    translationKey: 'chalkboard.defensive.team.total_centers_received',
    singleName: 'Centro recibido',
  },
  {
    name: '',
    color: '#4DB6AC',
    points: [1, 2, 3],
    categories: ['98_r', '101_r', '104_r', '105_r', '109_r', '112_r', '115_r', '116_r'],
    invert: [98, 101, 104, 105, 109, 112, 115, 116],
    translationKey: 'chalkboard.defensive.team.successful_centers_by_opponent',
    singleName: 'Centro acertado',
  },
  {
    name: '',
    color: '#00FF00',
    points: [1, 2, 3],
    categories: ['33_r'],
    invert: [33],
    translationKey: 'chalkboard.defensive.team.offsides_caused',
    singleName: 'Fuera de lugar',
  },
  {
    name: '',
    color: '#FF3399',
    points: [1, 2],
    categories: [483],
    translationKey: 'chalkboard.defensive.team.balls_recovered_in_challenge',
    singleName: 'Balón recuperado',
  },
  {
    name: '',
    color: '#B4005A',
    points: [1, 2],
    categories: [484],
    translationKey: 'chalkboard.defensive.team.balls_recovered_without_challenge',
    singleName: 'Balón recuperado',
  },
  {
    name: '',
    color: '#3A3838',
    points: [1],
    categories: [5],
    translationKey: 'chalkboard.defensive.team.successful_1_on_1',
    singleName: '1 vs 1 defensivo',
  },
  {
    name: '',
    color: '#00B050',
    points: [1],
    categories: [209],
    translationKey: 'chalkboard.defensive.team.unsuccessful_1_on_1',
    singleName: '1 vs 1 defensivo',
  },
  {
    name: '',
    color: '#305496',
    points: [1, 2],
    categories: [23],
    translationKey: 'chalkboard.defensive.team.balls_won_own_penalty_box',
    singleName: 'Balón ganado',
  },
  {
    name: '',
    color: '#FF9966',
    points: [1, 2, 3],
    categories: [24],
    translationKey: 'chalkboard.defensive.team.arial_game_rest_pitch',
    singleName: 'Juego aéreo',
  },
  {
    name: '',
    color: '#700000',
    points: [1],
    categories: [518],
    translationKey: 'chalkboard.defensive.team.slide_tackles',
    singleName: 'Barrida',
  },
  {
    name: '',
    color: '#CC0000',
    points: [1],
    categories: [34],
    translationKey: 'chalkboard.defensive.team.clearances',
    singleName: 'Rechace',
  },
];
